export const BIND_WALLET_SIGNATURE = `By signing this message, you allow us to bind your wallet address with the provided email address {email}.
Signature expiry: <{datetime}>`;

export const LOGIN_WITH_WALLET_SIGNATURE = `By signing this message, you allow us to use your wallet to authorize the login.
Signature expiry: <{datetime}>`;

export const MIGRATION_SIGNATURE = `By signing this message, you allow us to migrate your wallet/email account to the new wallet account : (new address:{address}).
Signature expiry: <{datetime}>`;
